"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.asyncFirst = asyncFirst;
exports.default = void 0;

var _asyncFirstOr = require("../$first-or/async-first-or");

function asyncFirst(iterable) {
  return (0, _asyncFirstOr.asyncFirstOr)(iterable, undefined);
}

var _default = asyncFirst;
exports.default = _default;